import {Component} from '@angular/core';
import {MatTab, MatTabGroup, MatTabLabel} from '@angular/material/tabs';
import {BlueprintsComponent} from '../blueprints/blueprints.component';
import {MarginsComponent} from '../margins/margins.component';
import {ReportingComponent} from '../reporting/reporting.component';



@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    imports: [
        MatTabGroup,
        MatTab,
        BlueprintsComponent,
        MarginsComponent,
        ReportingComponent,
        MatTabLabel
    ],
    styleUrls: ['./admin.component.scss']
})
export class AdminComponent {

}
